import { render, staticRenderFns } from "./MovieForm.vue?vue&type=template&id=1b049163&scoped=true"
import script from "./MovieForm.vue?vue&type=script&lang=js"
export * from "./MovieForm.vue?vue&type=script&lang=js"
import style0 from "./MovieForm.vue?vue&type=style&index=0&id=1b049163&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b049163",
  null
  
)

export default component.exports